export default __webpack_public_path__ + "static/media/jira-logo.1ff09330.svg";